<template>
    <div>
        <div>
            <b-button variant="primary" class="mt-25 mt-md-0" @click="openModal">
                <feather-icon icon="SearchIcon" size="15" class="mr-25" />
                <span class="font-weight-bold">Pilih/Cari BMD</span>
            </b-button>
        </div>
        <b-modal v-model="showModal" hide-footer ok-only ok-title="Ok" size="xl" :no-close-on-backdrop="true"
            title="Daftar Register BMD Inventarisasi KIB B" @hidden="onModalClose" @ok="onModalConfirm">
            <div class="mb-2">
                <template v-if="['Super Admin', 'admin', 'internal', 'pelaksana-suban'].includes(cookiesJenisAkun)">
                    <div class="row mb-1">
                        <div class="col-12">
                            <div class="border rounded bg-light-warning p-1 text-center">
                                <span>Silahkan pilih Kolok untuk menampilkan data BMD</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6">
                            <b-form-group label="Wilayah" label-for="wilayahFilter">
                                <b-overlay :show="isLoadWilayah" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <v-select id="wilayahFilter" v-model="formFilter.wilayah" label="text"
                                        :options="dsWilayah" @input="setFilterWilayah" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6">
                            <b-form-group label="PD/UKPD/UPB" label-for="kolokFilter">
                                <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <v-select id="kolokFilter" v-model="formFilter.kolok" label="text" :options="dsKolok"
                                        @input="setFilterKolok" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                    </div>

                </template>
                <div class="row mb-2">
                    <b-input-group>
                        <b-input-group-prepend>
                            <v-select id="searchOpt" class="search-filter-option-select"
                                v-model="formFilterDataBmd.key_cari" label="text" :options="searchOptions" />
                        </b-input-group-prepend>
                        <b-form-input id="Kata" v-model="formFilterDataBmd.cari"
                            placeholder="Pencarian data BMD, pilih kata kunci pencarian lalu tekan enter" type="text"
                            class="d-inline-block" @keyup.enter="handleSearch" />
                    </b-input-group>
                    <!-- <div class="col-12">
                        <b-form-group>
                            <b-form-input id="search-data-bmd" v-model="formFilterDataBmd.cari"
                                placeholder="Pencarian data BMD, ketik kata kunci pencarian lalu tekan enter" type="text"
                                class="d-inline-block" @keyup.enter="handleSearch" />
                        </b-form-group>
                    </div> -->
                </div>
                <div class="row">
                    <div class="col-12">
                        <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                            enabled: true, perPage: row, jumpFirstOrLast: true,
                        }" :totalRows="totalRecords" :is-loading="isLoadingTable" mode="remote"
                            @on-sort-change="onSortChange">
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field === 'aksi'" style="margin-left: 6px">
                                    <b-button variant="primary" class="btn-icon" @click="confirmPilih(props.row)">
                                        <feather-icon icon="CheckCircleIcon" class="mr-25" /> Pilih
                                    </b-button>
                                </div>
                                <div v-else-if="props.column.field === 'tgl_oleh'" class="text-right">
                                    <span>
                                        <span>{{ parserValue('dateOnly', props.row['tgl_oleh']) || '-' }}</span>
                                    </span>
                                </div>
                                <div v-else-if="props.column.field === 'total_harga'" class="text-right">
                                    <span>
                                        {{ `${new Intl.NumberFormat('id-ID', {
                                            maximumFractionDigits: 2,
                                        }).format(props.formattedRow[props.column.field])}` }}
                                    </span>
                                </div>
                            </template>
                            <template slot="pagination-bottom">
                                <div class="d-flex justify-content-center flex-wrap" style="gap: 15px;">
                                    <div class="d-flex align-items-center mb-0 mt-1">
                                        <span class="text-nowrap"> Menampilkan 1 hingga </span>
                                        <b-form-select v-model="row" :options="['10','25','50']" class="mx-1"
                                            @input="handlePageChange" />
                                        <span class="text-nowrap">
                                            dari {{ totalRecords }} entri
                                        </span>
                                    </div>
                                    <div>
                                        <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number
                                            last-number align="right" prev-class="prev-item" next-class="next-item"
                                            class="mt-1 mb-0" @change="handleChangePage">
                                            <template #prev-text>
                                                <feather-icon icon="ChevronLeftIcon" size="18" />
                                            </template>
                                            <template #next-text>
                                                <feather-icon icon="ChevronRightIcon" size="18" />
                                            </template>
                                        </b-pagination>
                                    </div>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import { onMounted, ref, watch, watchEffect } from '@vue/composition-api'
import vSelect from "vue-select";
import Ripple from 'vue-ripple-directive'
import daftarBmd from "@/composables/b/daftarBmd";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import moment from 'moment'
import masterBRef from "@/composables/master/masterBRef";
import { parserValue } from '@/libs/helper'
import searchOpt from "@/composables/b/searchOpt";

export default {
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, context) {
        const g = context.root;
        const year = g.$cookies.get("tahun") || moment().format('YYYY');
        const showModal = ref(false);
        const cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));
        const formFilter = ref({
            tahun: year,
            wilayah: null,
            kolok: null
        });
        const filterValue = ref({
            tahun: year,
            wilayah: (['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun"))) ? g.$cookies.get('wilayah') : null,
            kolok: (['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun"))) ? g.$cookies.get('kolok') : g.$route.query.kolok || null
        });

        const openModal = () => {
            showModal.value = true;
        }

        /* Dataset */
        const isLoadWilayah = ref(false);
        const dsWilayah = ref([]);
        const getDsWilayah = () => {
            dsWilayah.value = [];
            isLoadWilayah.value = true;
            masterBRef.getWilayah(g).then(res => {
                if (res.success) {
                    dsWilayah.value = res.rows;
                }
                isLoadWilayah.value = false;

            }).catch(err => {
                isLoadWilayah.value = false;
                dsWilayah.value = [];
                console.log(err)
            });
        };
        getDsWilayah();
        const changeWilayah = () => {
            formFilter.value.kolok = null
            getDsKolok()
        }
        const isLoadKolok = ref(false);
        const dsKolok = ref([]);
        const getDsKolok = (searchKolok = "") => {
            dsKolok.value = [];
            isLoadKolok.value = true;
            let params = {
                tahun: filterValue.value.tahun,
                wilayah: filterValue.value.wilayah,
                cari: searchKolok,
            };
            masterBRef.getKolokDs(g, params).then(res => {
                if (res.success) {
                    dsKolok.value = res.rows;
                }
                isLoadKolok.value = false;
            }).catch(err => {
                isLoadKolok.value = false;
                console.log(err)
            });

        };
        getDsKolok();


        const setFilterWilayah = () => {
            filterValue.value.wilayah = formFilter.value.wilayah.value;
            getDsKolok()
        };

        const setFilterKolok = () => {
            filterValue.value.kolok = (formFilter.value.kolok) ? formFilter.value.kolok.value : null;
            getDataBmd();
        };

        watchEffect(() => {
            formFilter.value.kolok = dsKolok.value.find(item => item.value == filterValue.value.kolok)
        })
        watch(showModal, (val) => {
            if (val) {
                if (filterValue.value.kolok != null) {
                    getDataBmd();
                }
            }
        });

        //variable untuk table
        const start = ref(0);
        const rows = ref([]);
        const row = ref(10);
        const totalRecords = ref(0);
        const sortColumn = ref("");
        const order = ref("");
        const isLoadingTable = ref(false);
        const formFilterDataBmd = ref({
            limit: row.value,
            start: start.value,
            cari: null,
            key_cari: { text: '-- Pilih Key --', value: '' },
        });
        const getDataBmd = () => {
            isLoadingTable.value = true;
            rows.value = [];
            let params = {
                filter_kolok: filterValue.value.kolok,
                limit: formFilterDataBmd.value.limit,
                start: formFilterDataBmd.value.start,
                cari: formFilterDataBmd.value.cari,
                key_cari: formFilterDataBmd.value.key_cari.value,
                filter_list: 'blm_ditautkan',
                request_from: 'web',
            }
            daftarBmd.getDataBmdPendalamanPendataan(g, params).then(resp => {
                if (resp.success) {
                    rows.value = resp.rows;
                    totalRecords.value = resp.totalRows;
                } else {
                    rows.value = [];
                    totalRecords.value = 0;
                }
                isLoadingTable.value = false;
            }).catch((err) => {
                console.log(err)
                isLoadingTable.value = false;
            });
        };
        const handleSearch = (searching) => {
            formFilterDataBmd.value.start = 0;
            getDataBmd();
        };

        const handlePageChange = (length) => {
            formFilterDataBmd.value.limit = length;
            getDataBmd();
        };

        const handleChangePage = (page) => {
            formFilterDataBmd.value.start = (page - 1) * row.value;
            getDataBmd();
        };

        const onSortChange = (params) => {
            sortColumn.value = params[0].field;
            order.value = params[0].type;
            getDataBmd();
        };

        const confirmPilih = (data) => {
            data.tahun = year;
            context.emit('dialogConfirm', data);
            showModal.value = false;
        };

        /* Search Option */
        const searchOptions = ref([]);
        const getSearchOptions = () => {
            searchOpt.getSearchOpt(g, { list: 'daftar_bmd' }).then(resp => {
                if (resp.success) {
                    searchOptions.value = resp.rows
                } else {
                }
                searchOptions.value.unshift({ text: '-- Pilih Key --', value: '' })

            }).catch(err => {
                console.log(err)
            })
        };
        getSearchOptions();
        return {
            parserValue,
            showModal,
            cookiesJenisAkun,
            formFilter,
            filterValue,

            isLoadWilayah,
            dsWilayah,
            changeWilayah,

            isLoadKolok,
            dsKolok,

            /* Table */
            getDataBmd,
            formFilterDataBmd,
            handleSearch,
            handlePageChange,
            handleChangePage,
            onSortChange,
            rows,
            start,
            row,
            totalRecords,
            sortColumn,
            order,
            isLoadingTable,
            confirmPilih,

            setFilterWilayah,
            setFilterKolok,
            openModal,
            searchOptions
        }
    },
    components: {
        VueGoodTable,
        vSelect,
    },
    methods: {
        onModalClose() {
            this.$emit('closeDialog');
        },
        onModalConfirm() {
            console.log('Modal confirmed ' + this.showModal);
        },
    },
    data() {
        return {
            columns: [
                {
                    label: "Aksi",
                    field: "aksi",
                    width: '110px',
                    thClass: 'text-uppercase bg-light-primary pb-1 px-0 text-center',
                    sortable: false,
                },
                {
                    label: "Guid ID",
                    field: "guid_aset",
                    width: '350px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kolok",
                    field: "kolok",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nalok",
                    field: "nalok",
                    width: '400px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kode Barang",
                    field: "kobar_108",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Register",
                    field: "noreg_108",
                    width: '175px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nama Barang",
                    field: "nabar_108",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tanggal Perolehan",
                    field: "tgl_oleh",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Total Harga",
                    field: "total_harga",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Bahan",
                    field: "bahan",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Merk",
                    field: "merk",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tipe",
                    field: "tipe",
                    width: '350px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Chasis",
                    field: "nochasis",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Mesin",
                    field: "nomesin",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Polisi",
                    field: "nopol",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor BPKB",
                    field: "nobpkb",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
            ],
        }
    },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
